export default __webpack_public_path__ + "static/media/IF.371c879e.svg";